// `capability` hides a section from people without it (roles and teams, TC-groups).
export const accountSections = [
  { label: 'My profile', route: 'settings-profile' },
  { label: 'Company settings', route: 'settings-branding', capability: 'branding.manage' },
  { label: 'People', route: 'settings-team' },
  { label: 'Teams', route: 'settings-teams', capability: 'teams.manage' },
  { label: 'Billing & usage', route: 'settings-billing', capability: 'billing.manage' },
  { label: 'Integrations', route: 'settings-integrations', capability: 'integrations.manage' }
]

export const sectionsFor = can => accountSections.filter(section => !section.capability || can(section.capability))
